import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';
import { saveAs } from 'file-saver';



@Injectable()
export class LicitacaoService {
    urlObterQuestoes: string;
    codigoModuloLicitacao = 4;
    analiseAtual: any = null;
    idPaginaLicitacao: string = "957";
    resumoAnalise: any;

    constructor(public http: HttpClient,
        private gestaoPcaService: GestaoPcaService,
        private utilService: UtilService) {
    }

    public obterDadosPrevisualizacao(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterPreviewCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterIdPaginaLicitacao() {
        return this.idPaginaLicitacao;
    }

    public obterRelatorioInspecao(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterRelatorio?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public downloadRelatorioInspecao(idDoc) {
        var headers = new HttpHeaders();
        headers.append('responseType', 'arraybuffer');
        this.utilService.getJSON("licitacao/downloadDocumento/" + idDoc)
            .subscribe(data => {
                let contentType = "data:" + data.mimeType + ";base64";

                let byteCharacters = atob(data.decodedFile);

                let byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: contentType });
                //return file;
                saveAs(file, data.filename);
            },
            error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
    }

    public salvarRelatorioInspecao(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarRelatorio?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterListaAnalisesJur(codModulo): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterAnaliseJurisdicionado?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterListaAnalises(codModulo): Observable<any> {
        this.urlObterQuestoes = "licitacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterVisaoGerencial(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterVisaoGerencial?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterElementosDespesa(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterElementosDespesa?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarVisaoGerencial(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarVisaoGerencial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterDirecionamentoFornecedores(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterDirecionamentoDeFornecedores?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarDirecionamentoDeFornecedores(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarDirecionamentoDeFornecedores?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterBensEServicos(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterBensEServicos?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterAquisicaoDeBensEServicos(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterAquisicaoDeBensEServicos?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarAnalisesLicitacao(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarAnalisesLicitacao?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterDispensaIncompativel(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterDispensaIncompativel?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterInexigibilidadeIncompativel(): Observable<any> {
        this.urlObterQuestoes = "licitacao/inexigibilidadeIncompativel?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterObrasAcimaLimite(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterContratacaoObrasAcimaLimite?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterOutrosServicosLimiteDispensa(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterContratosServicosComprasAcimaDoLimite?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterModalidadeVersusContratado(): Observable<any> {
        this.urlObterQuestoes = "licitacao/obterModalidadeLicitacaoVsValor?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarAnalisesLicitacaoIncompativel(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarAnalisesLicitacaoIncompativel?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarAnalisesLicitacaoModelo(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarAnalisesLicitacaoModelo?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarAnalisesLicitacaoSimples(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/salvarAnalisesLicitacaoSimples?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarDirecionamentoDeFornecedores(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/finalizarDirecionamentoDeFornecedores?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAnalisesLicitacao(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/finalizarAnalisesLicitacao?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAnalisesLicitacaoModelo(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/finalizarAnalisesLicitacaoModelo?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAnalisesLicitacaoSimples(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/finalizarAnalisesLicitacaoSimples?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAnalisesLicitacaoIncompativel(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "licitacao/finalizarAnalisesLicitacaoIncompativel?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public submeterAnaliseNoCertificado(idAnalise, dadosAnalise, cdAnalise): Observable<any> {

        this.resumoAnalise = {
            idModuloAnalise: dadosAnalise.idModuloAnalise,
            dsResultadoAnalise: dadosAnalise.resumoAnalise,
            idStatusAnalise: 0,
            dsStatusAnalise: "",
            idModuloPca: 0,
            cdAnalise: cdAnalise,
            dsDescricaoAnalise: ""
        };

        this.urlObterQuestoes = "licitacao/submterAnalise?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, this.resumoAnalise);
    }

    public submeterAnaliseNoCertificadoVisao(idAnalise, dadosAnalise, cdAnalise): Observable<any> {

        this.resumoAnalise = {
            idModuloAnalise: dadosAnalise.idModuloAnalise,
            dsResultadoAnalise: dadosAnalise.resultadoAnalise,
            idStatusAnalise: 0,
            dsStatusAnalise: "",
            idModuloPca: 0,
            cdAnalise: cdAnalise,
            dsDescricaoAnalise: ""
        };

        this.urlObterQuestoes = "licitacao/submterAnalise?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, this.resumoAnalise);
    }
}


// WEBPACK FOOTER //
// ./src/providers/licitacao-service.ts